import { useEffect, useState } from 'react'
import api      from '../../services/apiClient'
import Button   from '../Shared/Button'
import Input    from '../Shared/Input'
import Modal    from '../Shared/Modal'
import Spinner  from '../Shared/Spinner'
import Tag      from '../Shared/Tag'

export default function CommunityFeed() {
  const [posts,setPosts]       = useState([])
  const [loading,setLoading]   = useState(true)
  const [creating,setCreating] = useState(false)
  const [title,setTitle]       = useState('')
  const [body,setBody]         = useState('')

  /* fetch */
  useEffect(() => {
    api.get('/api/community/posts?limit=50')
      .then(({ data }) => setPosts(data))
      .catch(err => {
        if (err.response?.status === 404) {
          console.warn("Community posts endpoint not found (404) — safe to ignore.");
          setPosts([]); // treat it like an empty feed
        } else {
          console.error("❌ Community posts fetch failed:", err);
        }
      })
      .finally(() => setLoading(false));
  }, []);
  

  
  /* create */
  const createPost = async()=>{
    if(!title.trim() || !body.trim()) return
    const {data}  = await api.post('/api/community/posts',{title,body})
    setPosts([data,...posts])
    setCreating(false); setTitle(''); setBody('')
  }

  /* like */
  const toggleLike = async(id)=>{
    setPosts(p=>p.map(pp=>pp.id===id?{...pp, liked:!pp.liked, likes: pp.likes+(pp.liked?-1:1)}:pp))
    api.post(`/api/community/posts/${id}/toggle-like`).catch(()=>{}) // fire‑and‑forget
  }

  if(loading) return <div className="flex justify-center py-12"><Spinner/></div>

  return (
    <div className="p-unit space-y-unit">
      <div className="flex justify-between items-center">
        <h2 className="font-semibold text-charcoal">Community Feed</h2>
        <Button intent="primary" size="sm" onClick={()=>setCreating(true)}>+ Post</Button>
      </div>

      {posts.map(p=>(
        <article key={p.id} className="border rounded-2xl p-unit hover:bg-soft-yellow/30">
          <header className="flex items-center gap-2 mb-1">
            <span className="font-medium">{p.author_name}</span>
            <span className="text-xs text-slate-gray">{new Date(p.created_at).toLocaleString()}</span>
            {p.tags?.map(t=><Tag key={t}>{t}</Tag>)}
          </header>
          <h3 className="font-semibold">{p.title}</h3>
          <p className="text-sm whitespace-pre-line">{p.body}</p>
          <footer className="flex items-center gap-4 mt-1 text-xs">
            <button
              onClick={()=>toggleLike(p.id)}
              className={`flex items-center gap-1 ${p.liked?'text-amber-600':'text-slate-gray hover:text-charcoal'}`}
            >
              ❤️ {p.likes}
            </button>
            <span>💬 {p.comments_count}</span>
          </footer>
        </article>
      ))}

      {/* new post modal */}
      <Modal open={creating} title="New community post" onClose={()=>setCreating(false)}>
        <div className="space-y-4">
          <Input label="Title" value={title} onChange={e=>setTitle(e.target.value)} autoFocus />
          <textarea
            className="w-full border rounded p-2 h-32 text-sm resize-none"
            placeholder="Share a question, tip, or story…"
            value={body}
            onChange={e=>setBody(e.target.value)}
          />
          <div className="flex justify-end gap-2">
            <Button intent="secondary" onClick={()=>setCreating(false)}>Cancel</Button>
            <Button intent="primary"  onClick={createPost}>Publish</Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
